import { CoreFlightSteps } from "@b2bportal/core-utilities";

import { useValidateFlightShopRoute } from "@tenant/flights";

export const useReturnPageRoute = () => {
  // Validate that the user is able to enter Return page.
  // Parsing query parameters is unnecessary as deep linking is not supported on return page.
  // Deep linking will redirect the user to Departure page, where we validate the url.
  useValidateFlightShopRoute(CoreFlightSteps.RETURN);
  return {};
};
